var map = {
	"./Saly.png": "a75c",
	"./Sphere-White-Matte.png": "50f6",
	"./accounts.svg": "8b4d",
	"./big-Sphere-White-Matte.png": "d101",
	"./blue-pill.png": "1423",
	"./candidates.svg": "03c5",
	"./companies/intern.png": "3435",
	"./companies/internships.png": "aa16",
	"./companies/public.png": "8dce",
	"./companies/search.png": "69f6",
	"./full-Pill-Blue-Glossy.png": "6cdc",
	"./heatmap.svg": "d623",
	"./leads.svg": "cb97",
	"./orange-box.png": "7b7a",
	"./organization.svg": "d151",
	"./reports.svg": "a7b5",
	"./school/account.png": "300f",
	"./school/heatmap.png": "827a",
	"./school/instructor.png": "dc4a6",
	"./school/report.png": "e60f",
	"./school/school.png": "3a0f",
	"./school/skills.png": "82c5",
	"./school/task.png": "2961",
	"./section-one-bj.png": "2a58",
	"./skills.svg": "aa24",
	"./students/employments.png": "5c5e",
	"./students/projects.png": "11c0",
	"./students/public-info.png": "4b72",
	"./students/qulification.png": "0c74",
	"./students/skills.png": "163b",
	"./tasks.svg": "eb34",
	"./toroid-purple.png": "6e4e",
	"./toroid-yellow.png": "091b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1bed";